module.exports = "/assets/data/21769cffbf27dae02fbc48e6d6d44f37-NG5.data.json";